/**
 * ASYCO Inventory Visibility — asyco-inventory.js
 *
 * Objetivo:
 *  - Ocultar productos agotados (stock 0) de TODOS los listados del sitio:
 *    colecciones, búsqueda, predictive search, carruseles, home, relacionados.
 *  - Mantener intacta la URL directa (/products/handle) para SEO.
 *  - Mostrar mensaje amable si una colección queda vacía tras filtrar.
 *
 * Estrategia:
 *  Horizon 3.4 marca automáticamente las tarjetas agotadas en COLECCIONES
 *  con la clase .product-grid__item--soldout en el <li> padre. Pero NO lo
 *  hace en la página de búsqueda ni en el predictive search. Este script
 *  detecta las tarjetas con texto "Agotado" y les aplica una clase
 *  equivalente para que el CSS las oculte uniformemente.
 *
 *  Cuando el CRM reponga stock en Shopify, los productos reaparecen
 *  automáticamente en el siguiente render de la página (sin re-deploy).
 */

(function () {
  'use strict';

  /* ─── Configuración ───────────────────────────────────────────────── */
  var SOLDOUT_REGEX = /\bagotado\b|\bsold\s*out\b/i; // idioma ES + EN
  var HIDDEN_CLASS = 'asyco-hidden-soldout';
  var EMPTY_MSG_ID = 'asyco-collection-empty';

  /* ─── Detectar si un <product-card> está agotado ─────────────────── */
  function esAgotado(card) {
    if (!card) return false;
    // 1) señal principal: texto visible "Agotado" dentro del card
    var texto = card.innerText || '';
    return SOLDOUT_REGEX.test(texto);
  }

  /* ─── Obtener el wrapper correcto a ocultar ──────────────────────── */
  /* Preferimos ocultar el <li> padre (para no romper el grid).         */
  /* Si no hay <li>, caemos al parentElement directo.                   */
  function getWrapper(card) {
    return card.closest('li, .product-grid__item, .swiper-slide, .collection-grid__item') || card.parentElement;
  }

  /* ─── Marcar todas las cards agotadas de la página ───────────────── */
  function marcarAgotados(root) {
    root = root || document;
    var cards = root.querySelectorAll('product-card');
    cards.forEach(function (card) {
      if (esAgotado(card)) {
        var w = getWrapper(card);
        if (w && !w.classList.contains(HIDDEN_CLASS)) {
          w.classList.add(HIDDEN_CLASS);
        }
      }
    });
  }

  /* ─── Mostrar mensaje si una colección queda totalmente vacía ────── */
  function verificarColeccionVacia() {
    // Solo corre en URLs de colección o búsqueda
    var path = location.pathname;
    if (path.indexOf('/collections/') !== 0 && path.indexOf('/search') !== 0) return;

    // Encontrar el contenedor del grid de productos
    var grid = document.querySelector('.product-grid, product-grid, results-list .product-grid, main .product-grid');
    if (!grid) return;

    var items = grid.querySelectorAll(':scope > li, :scope > .product-grid__item, :scope > div');
    if (items.length === 0) return;

    // Contar visibles (no ocultos por soldout)
    var visibles = 0;
    items.forEach(function (el) {
      if (!el.classList.contains(HIDDEN_CLASS) &&
          !el.classList.contains('product-grid__item--soldout')) {
        visibles++;
      }
    });

    // Remover mensaje previo si ya había
    var prev = document.getElementById(EMPTY_MSG_ID);
    if (prev) prev.remove();

    // Si no hay visibles, mostrar mensaje amable
    if (visibles === 0) {
      var msg = document.createElement('div');
      msg.id = EMPTY_MSG_ID;
      msg.className = 'asyco-collection-empty';
      msg.innerHTML = [
        '<div class="asyco-empty__icon">📦</div>',
        '<h3 class="asyco-empty__title">Estamos reponiendo esta categoría</h3>',
        '<p class="asyco-empty__text">Los productos volverán muy pronto. Mientras tanto, explora otras categorías.</p>',
        '<a href="/collections/all" class="asyco-empty__cta">Ver todos los productos disponibles</a>'
      ].join('');
      grid.parentNode.insertBefore(msg, grid);
    }
  }

  /* ─── Ejecución principal ──────────────────────────────────────── */
  function run() {
    marcarAgotados();
    verificarColeccionVacia();
  }

  /* ─── Observar cambios dinámicos (predictive search, filtros AJAX, paginación) ─── */
  function observarCambios() {
    var debounceTimer = null;
    var observer = new MutationObserver(function (mutations) {
      var hayNuevasCards = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'PRODUCT-CARD' ||
              (n.querySelector && n.querySelector('product-card'))) {
            hayNuevasCards = true;
            break;
          }
        }
        if (hayNuevasCards) break;
      }
      if (hayNuevasCards) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(run, 50);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ─── Init ────────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      observarCambios();
    });
  } else {
    run();
    observarCambios();
  }

  /* ─── API pública por si se necesita invocar manualmente ─────────── */
  window.ASYCO_INVENTORY = {
    refresh: run,
    isAgotado: esAgotado
  };
})();
